import { lazy } from "react";
import RouteGuard from "../routerPermission";

const OrderManagementPage = lazy(
  () => import("@/pages/vendor/orders/OrderManagementPage"),
);
const AdminOrderDetail = lazy(
  () => import("@/widgets/order-management/OrderDetail"),
);

const OrderRoutes = {
  path: "orders",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="order" action="read">
          <OrderManagementPage />
        </RouteGuard>
      ),
    },
    {
      path: ":orderId",
      element: (
        <RouteGuard resource="order" action="read">
          <AdminOrderDetail />
        </RouteGuard>
      ),
    },
  ],
};

export default OrderRoutes;
